import React from 'react';
import styled from 'styled-components';
import { Page } from '/imports/ui/Page';
import { NotPermittedPage } from '/imports/ui/NotPermittedPage';
import { useUser } from '/imports/hooks';

const EnvironmentPageStyled = styled(Page)`
  padding: 1rem;
  a {
    display: block;
    margin: 2rem 0;
  }
`;

/** Page with links to switch between the production, staging, and development environments. */
export const EnvironmentPage = () => {
  const user = useUser();
  if (user && !user.isSuperUser) return <NotPermittedPage />;
  return (
    <EnvironmentPageStyled>
      <h1>Switch Enviroment</h1>
      <a href="https://app2.luminia.io">Production</a>
      <a href="https://staging2.luminia.io">Staging</a>
      <a href="https://development2.luminia.io">Development</a>
    </EnvironmentPageStyled>
  );
};